module.exports = __webpack_public_path__ + "static/dennis-okeefe-28e0a78328716538526aba9b4bfb2f50.png";